import(/* webpackMode: "eager" */ "/home/ubuntu/download/69c4a12d7d947e00141f797b/rinse_1774493997096/src/app/page.tsx");
